<template>
  <div>
    <table id="TariffCalculator" cellspacing="0">
      <colgroup>
        <col style="width: 80%" />
        <col style="width: 20%" />
      </colgroup>
      <thead>
        <tr>
          <th>{{ t[lang].DESCRIPTION }}</th>
          <th style="text-align: right; margin-right: 1em;">
            {{ t[lang].AMOUNT }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="result in calculationResults" :key="result.Description">
          <td>
            <label>{{ result.Description }}</label>
          </td>
          <td style="text-align: right; margin-right: 1em;">
            <label>
              {{ formatCurrency(result.Amount) }}
            </label>
          </td>
        </tr>

        <tr class="subtotal">
          <td>
            <label style="font-weight: bold;"> {{ t[lang].TOTAL }}: </label>
          </td>
          <td style="text-align: right; margin-right: 1em;">
            <label style="font-weight: bold;">
              {{ totalChargeFormatted }}
            </label>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      style="border: none; color: #c7b729;"
      class="avia-button avia-icon_select-no avia-color-theme-color avia-size-small avia-position-left"
      @click="onAnotherCalculationClicked"
    >
      {{ t[lang].ANOTHER_CALCULATION }}
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import translations from '../translations'
import utils from '../utils'

export default {
  name: 'CalculationResultsComponent',

  data() {
    return {
      t: translations,
    }
  },

  computed: {
    lang() {
      return window.location.href.indexOf('/fr/') >= 0 ? 'fr' : 'en'
    },

    totalChargeFormatted() {
      return utils.formatMoney(this.totalCharge)
    },

    ...mapState(['calculationResults']),
    ...mapGetters(['totalCharge']),
  },

  methods: {
    formatCurrency(value) {
      return utils.formatMoney(value)
    },

    onAnotherCalculationClicked() {
      this.$emit('reset')
    },
  },
}
</script>
